export const SpellFXMetadata = [
    {
      "animationName": "Red Arrow",
      "startCol": 0,
      "startRow": 0,
      "endCol": 7,
      "endRow": 0,
      "directional": true
    },
    {
      "animationName": "Green Arrow",
      "startCol": 0,
      "startRow": 1,
      "endCol": 7,
      "endRow": 1,
      "directional": true
    },
    {
      "animationName": "Pink Arrow",
      "startCol": 0,
      "startRow": 2,
      "endCol": 7,
      "endRow": 2,
      "directional": true
    },
    {
      "animationName": "Pink Lightning",
      "startCol": 0,
      "startRow": 3,
      "endCol": 7,
      "endRow": 3,
      "directional": true
    },
    {
      "animationName": "Green Projectile",
      "startCol": 0,
      "startRow": 4,
      "endCol": 7,
      "endRow": 4,
      "directional": true
    },
    {
      "animationName": "Small Green Projectiles",
      "startCol": 0,
      "startRow": 5,
      "endCol": 7,
      "endRow": 5,
      "directional": true
    },
    {
      "animationName": "Fire Projectile",
      "startCol": 0,
      "startRow": 6,
      "endCol": 7,
      "endRow": 6,
      "directional": true
    },
    {
      "animationName": "Fire Arrow",
      "startCol": 0,
      "startRow": 7,
      "endCol": 7,
      "endRow": 7,
      "directional": true
    },
    {
      "animationName": "Ice Projectile",
      "startCol": 0,
      "startRow": 8,
      "endCol": 7,
      "endRow": 8,
      "directional": true
    },
    {
      "animationName": "Ice Arrow",
      "startCol": 0,
      "startRow": 9,
      "endCol": 7,
      "endRow": 9,
      "directional": true
    },
    {
      "animationName": "Lightning",
      "startCol": 0,
      "startRow": 10,
      "endCol": 7,
      "endRow": 10,
      "directional": true
    },
    {
      "animationName": "Lightning Arrow",
      "startCol": 0,
      "startRow": 11,
      "endCol": 7,
      "endRow": 11,
      "directional": true
    },
    {
      "animationName": "Grey Bullet",
      "startCol": 0,
      "startRow": 12,
      "endCol": 7,
      "endRow": 12,
      "directional": true
    },
    {
      "animationName": "Yellow Bullet",
      "startCol": 0,
      "startRow": 13,
      "endCol": 7,
      "endRow": 13,
      "directional": true
    },
    {
      "animationName": "Ninja Star",
      "startCol": 0,
      "startRow": 14,
      "endCol": 7,
      "endRow": 14,
      "directional": true
    },
    {
      "animationName": "Pink Star Projectile",
      "startCol": 0,
      "startRow": 15,
      "endCol": 7,
      "endRow": 15,
      "directional": true
    },
    {
      "animationName": "Web",
      "startCol": 0,
      "startRow": 16,
      "endCol": 7,
      "endRow": 16,
      "directional": true
    },
    {
      "animationName": "Pink Ball Projectile",
      "startCol": 0,
      "startRow": 17,
      "endCol": 7,
      "endRow": 17,
      "directional": true
    },
    {
      "animationName": "Yellow Star Projectile",
      "startCol": 0,
      "startRow": 18,
      "endCol": 7,
      "endRow": 18,
      "directional": false
    },
    {
      "animationName": "Gold Sparkles",
      "startCol": 0,
      "startRow": 19,
      "endCol": 7,
      "endRow": 19
    },
    {
      "animationName": "Green Sparkles",
      "startCol": 0,
      "startRow": 20,
      "endCol": 7,
      "endRow": 20
    },
    {
      "animationName": "Blue Sparkles",
      "startCol": 0,
      "startRow": 21,
      "endCol": 7,
      "endRow": 21
    },
    {
      "animationName": "Orange Sparkles",
      "startCol": 0,
      "startRow": 22,
      "endCol": 7,
      "endRow": 22
    },
    {
      "animationName": "Pink Sparkles",
      "startCol": 0,
      "startRow": 23,
      "endCol": 7,
      "endRow": 23
    },
    {
      "animationName": "Red Sparkles",
      "startCol": 0,
      "startRow": 24,
      "endCol": 7,
      "endRow": 24
    },
    {
      "animationName": "Green Skull",
      "startCol": 0,
      "startRow": 25,
      "endCol": 7,
      "endRow": 25
    },
    {
      "animationName": "Yellow Key",
      "startCol": 0,
      "startRow": 26,
      "endCol": 7,
      "endRow": 26
    },
    {
      "animationName": "Skull Cross",
      "startCol": 0,
      "startRow": 27,
      "endCol": 7,
      "endRow": 27
    },
    {
      "animationName": "Shields",
      "startCol": 0,
      "startRow": 28,
      "endCol": 7,
      "endRow": 28
    },
    {
      "animationName": "Red Crosses",
      "startCol": 0,
      "startRow": 29,
      "endCol": 7,
      "endRow": 29
    },
    {
      "animationName": "Fire Ring",
      "startCol": 0,
      "startRow": 30,
      "endCol": 7,
      "endRow": 30
    },
    {
      "animationName": "Ice Ring",
      "startCol": 0,
      "startRow": 31,
      "endCol": 7,
      "endRow": 31
    },
    {
      "animationName": "Green Ring",
      "startCol": 0,
      "startRow": 32,
      "endCol": 7,
      "endRow": 32
    },
    {
      "animationName": "Pink Ring",
      "startCol": 0,
      "startRow": 33,
      "endCol": 7,
      "endRow": 33
    },
    {
      "animationName": "Yellow Star",
      "startCol": 0,
      "startRow": 34,
      "endCol": 7,
      "endRow": 34
    },
    {
      "animationName": "Blue Star",
      "startCol": 0,
      "startRow": 35,
      "endCol": 7,
      "endRow": 35
    },
    {
      "animationName": "Green Star",
      "startCol": 0,
      "startRow": 36,
      "endCol": 7,
      "endRow": 36
    },
    {
      "animationName": "White Crosses",
      "startCol": 0,
      "startRow": 37,
      "endCol": 7,
      "endRow": 37
    },
    {
      "animationName": "Spider Web",
      "startCol": 0,
      "startRow": 38,
      "endCol": 7,
      "endRow": 38
    },
    {
      "animationName": "Torch",
      "startCol": 0,
      "startRow": 39,
      "endCol": 7,
      "endRow": 39
    },
    {
      "animationName": "Frost",
      "startCol": 0,
      "startRow": 40,
      "endCol": 7,
      "endRow": 41,
      "fastAnimation": true
    },
    {
      "animationName": "Yellow Star Circle",
      "startCol": 0,
      "startRow": 42,
      "endCol": 6,
      "endRow": 43
    },
    {
      "animationName": "Circles",
      "startCol": 0,
      "startRow": 44,
      "endCol": 4,
      "endRow": 45
    },
    {
      "animationName": "Gold Shield Spiral",
      "startCol": 0,
      "startRow": 46,
      "endCol": 7,
      "endRow": 47,
      "fastAnimation": true
    },
    {
      "animationName": "Green Shield Spiral",
      "startCol": 0,
      "startRow": 48,
      "endCol": 7,
      "endRow": 49,
      "fastAnimation": true
    },
    {
      "animationName": "Blue Shield Spiral",
      "startCol": 0,
      "startRow": 50,
      "endCol": 7,
      "endRow": 51,
      "fastAnimation": true
    },
    {
      "animationName": "Pink Shield Spiral",
      "startCol": 0,
      "startRow": 52,
      "endCol": 7,
      "endRow": 53,
      "fastAnimation": true
    },
    {
      "animationName": "Blue Firework",
      "startCol": 0,
      "startRow": 54,
      "endCol": 7,
      "endRow": 55,
      "fastAnimation": true
    },
    {
      "animationName": "Red Firework",
      "startCol": 0,
      "startRow": 56,
      "endCol": 7,
      "endRow": 57,
      "fastAnimation": true
    },
    {
      "animationName": "Bubbles",
      "startCol": 0,
      "startRow": 58,
      "endCol": 2,
      "endRow": 60,
      "fastAnimation": true
    },
    {
      "animationName": "Shield",
      "startCol": 0,
      "startRow": 61,
      "endCol": 7,
      "endRow": 62,
      "fastAnimation": true
    },
    {
      "animationName": "Color Spiral",
      "startCol": 0,
      "startRow": 63,
      "endCol": 7,
      "endRow": 64
    },
    {
      "animationName": "Arm Flex",
      "startCol": 0,
      "startRow": 65,
      "endCol": 4,
      "endRow": 66,
      "fastAnimation": true
    },
    {
      "animationName": "Super Speed",
      "startCol": 0,
      "startRow": 67,
      "endCol": 7,
      "endRow": 68,
      "fastAnimation": true
    },
    {
      "animationName": "Target",
      "startCol": 0,
      "startRow": 69,
      "endCol": 7,
      "endRow": 70,
      "fastAnimation": true
    },
    {
      "animationName": "Yellow Shield Spiral",
      "startCol": 0,
      "startRow": 71,
      "endCol": 6,
      "endRow": 72,
      "fastAnimation": true
    },
    {
      "animationName": "Pink Star Circle",
      "startCol": 0,
      "startRow": 73,
      "endCol": 6,
      "endRow": 74
    },
    {
      "animationName": "Blue Star Circle",
      "startCol": 0,
      "startRow": 75,
      "endCol": 6,
      "endRow": 76
    },
    {
      "animationName": "Green Star Circle",
      "startCol": 0,
      "startRow": 77,
      "endCol": 6,
      "endRow": 78
    },
    {
      "animationName": "Gold Star Circle",
      "startCol": 0,
      "startRow": 79,
      "endCol": 6,
      "endRow": 80
    },
    {
      "animationName": "Bread",
      "startCol": 0,
      "startRow": 81,
      "endCol": 7,
      "endRow": 81
    },
    {
      "animationName": "Yellow Fire Ring",
      "startCol": 0,
      "startRow": 82,
      "endCol": 7,
      "endRow": 82
    },
    {
      "animationName": "Totems",
      "startCol": 0,
      "startRow": 83,
      "endCol": 7,
      "endRow": 83
    },
    {
      "animationName": "Eye Blink",
      "startCol": 0,
      "startRow": 84,
      "endCol": 7,
      "endRow": 84
    },
    {
      "animationName": "Pink Star",
      "startCol": 0,
      "startRow": 85,
      "endCol": 7,
      "endRow": 85
    },
    {
      "animationName": "Orange Star",
      "startCol": 0,
      "startRow": 86,
      "endCol": 7,
      "endRow": 86
    },
    {
      "animationName": "Red Eye Blink",
      "startCol": 0,
      "startRow": 87,
      "endCol": 6,
      "endRow": 88
    },
    {
      "animationName": "Eagle",
      "startCol": 0,
      "startRow": 89,
      "endCol": 7,
      "endRow": 89
    },
    {
      "animationName": "Sleep",
      "startCol": 0,
      "startRow": 90,
      "endCol": 6,
      "endRow": 91
    },
    {
      "animationName": "Armor",
      "startCol": 0,
      "startRow": 92,
      "endCol": 7,
      "endRow": 92
    },
    {
      "animationName": "Blind Eye Blink",
      "startCol": 0,
      "startRow": 93,
      "endCol": 7,
      "endRow": 93
    },
    {
      "animationName": "Fire Rain",
      "startCol": 0,
      "startRow": 94,
      "endCol": 7,
      "endRow": 96,
      "fastAnimation": true
    },
    {
      "animationName": "Blue Rain",
      "startCol": 0,
      "startRow": 97,
      "endCol": 7,
      "endRow": 99,
      "fastAnimation": true
    },
    {
      "animationName": "Green Rain",
      "startCol": 0,
      "startRow": 100,
      "endCol": 7,
      "endRow": 102,
      "fastAnimation": true
    },
    {
      "animationName": "Lightning Rain",
      "startCol": 0,
      "startRow": 103,
      "endCol": 7,
      "endRow": 105,
      "fastAnimation": true
    },
    {
      "animationName": "Pink Rain",
      "startCol": 0,
      "startRow": 106,
      "endCol": 7,
      "endRow": 108,
      "fastAnimation": true
    },
    {
      "animationName": "Rainbow Rain",
      "startCol": 0,
      "startRow": 109,
      "endCol": 7,
      "endRow": 111,
      "fastAnimation": true
    },
    {
      "animationName": "Spear",
      "startCol": 0,
      "startRow": 112,
      "endCol": 7,
      "endRow": 112,
      "directional": true,
      "customScale": 1.5
    },
    {
      "animationName": "Red Damage",
      "startCol": 0,
      "startRow": 113,
      "endCol": 2,
      "endRow": 113
    },
    {
      "animationName": "White Damage",
      "startCol": 0,
      "startRow": 114,
      "endCol": 2,
      "endRow": 114
    },
    {
      "animationName": "Blue Damage",
      "startCol": 0,
      "startRow": 115,
      "endCol": 2,
      "endRow": 115
    },
    {
      "animationName": "Green Damage",
      "startCol": 0,
      "startRow": 116,
      "endCol": 2,
      "endRow": 116
    },
    {
      "animationName": "Red Splat",
      "startCol": 0,
      "startRow": 117,
      "endCol": 2,
      "endRow": 117
    },
    {
      "animationName": "Electric Damage",
      "startCol": 0,
      "startRow": 118,
      "endCol": 2,
      "endRow": 118
    },
    {
      "animationName": "Fire Damage",
      "startCol": 0,
      "startRow": 119,
      "endCol": 2,
      "endRow": 119
    },
    {
      "animationName": "Poison Damage",
      "startCol": 0,
      "startRow": 120,
      "endCol": 2,
      "endRow": 120
    },
    {
      "animationName": "Sonic Damage",
      "startCol": 0,
      "startRow": 121,
      "endCol": 2,
      "endRow": 121
    },
    {
      "animationName": "Pink Damage",
      "startCol": 0,
      "startRow": 122,
      "endCol": 2,
      "endRow": 122
    },
    {
      "animationName": "Fat Red Arrow",
      "startCol": 0,
      "startRow": 123,
      "endCol": 7,
      "endRow": 123,
      "directional": true
    },
    {
      "animationName": "Wall Arrow",
      "startCol": 0,
      "startRow": 124,
      "endCol": 7,
      "endRow": 124,
      "directional": true
    }
  ];